/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { TenantId } from '@src/app/model/abstract-object';
import { DebtorsListPageNavRoute } from '@src/app/routes/debtors-list-page-nav';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { MessageService } from '@src/app/shared/message.service';
import { NrHelper } from '@src/app/shared/NrHelper';
import { TenantService } from '@src/app/shared/tenant.service';

export class DebtorStats {
    teamId: TenantId;
    debtors: {
        totalDebtors: string; 
        currentYear: string; 
        arrears: string;
        likelyReceipts: string;
    }
}
@Component({
    selector: 'app-debtors-widget',
    imports: [RouterLink, MatCardModule],
    templateUrl: './debtors-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class DebtorsWidgetComponent implements IWidget, OnInit {
    @Input() chosenWidget: ChosenWidget;

    title = $localize`Debtors`;
    host: ElementRef<Element> = inject(ElementRef);
    options: { name: string; action: () => void; }[];
    http = inject(HttpClient);
    tenantSvc = inject(TenantService);
    msgSvc = inject(MessageService);
    nrHelper = NrHelper;

    routerLink = DebtorsListPageNavRoute.getListRouterLink();

    data: DebtorStats;
    totalDebtors = 0;
    arrears = 0;

    ngOnInit(): void {
        this.http.get<DebtorStats>(this.tenantSvc.getPath('omc/dashboard/debtors')).subscribe( 
            data => this.data = data,
            error => this.msgSvc.showError(error, 'Request Summary')
        );        
    }
}
